import { useAtom } from 'jotai';
import * as React from 'react';
import styled from 'styled-components';

import * as icons from '@creditornot/alchemy-react/icons';
import { IconButton } from '@creditornot/cb-button';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { useToast } from 'common/hooks/useToast';
import { installAppStateAtom } from 'common/state/installAppState';

const InstallWrapper = styled.div`
  &:hover {
    cursor: pointer;
  }

  @media (display-mode: standalone) {
    button {
      display: none;
    }
  }

  /* stylelint-disable-next-line at-rule-prelude-no-invalid */
  @-moz-document url-prefix() {
    button {
      display: none;
    }
  }
`;

export const AppInstallButton = () => {
  const [{ bipEvent }, setInstallAppState] = useAtom(installAppStateAtom);
  const { addToast } = useToast();
  const formatMessage = useFormatMessage();

  const handleInstallClick = React.useCallback(() => {
    if (bipEvent?.prompt) {
      void bipEvent?.prompt();
      void bipEvent?.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          setInstallAppState({ bipEvent, installAttempted: true });
        }
      });
    } else {
      addToast({
        variant: 'error',
        title: formatMessage('app_installation.unable_to_install'),
        description: formatMessage('app_installation.install_the_app_manually'),
      });
      setInstallAppState({ bipEvent, installAttempted: true });
    }
  }, [bipEvent, setInstallAppState, addToast, formatMessage]);

  return (
    <InstallWrapper>
      <IconButton
        icon={icons.download}
        size="small"
        variant="brand"
        onClick={() => handleInstallClick()}
      />
    </InstallWrapper>
  );
};
